import { stringify } from 'qs';
import { Api as apiService } from '../api';
export class FormFieldsApi {
    static get(amount, categoryId, expenseSource, expenseTagIds, userProfileId, vendor, linkedAccountCardType) {
        const params = {
            amount: amount,
            category_id: categoryId,
            source: expenseSource,
            expense_tag_ids: expenseTagIds,
            user_profile_id: userProfileId,
            vendor: vendor,
            linked_account_card_type: linkedAccountCardType
        };
        let url = '/api/web/expenses/form_fields?';
        for (const key of Object.keys(params)) {
            const value = params[key];
            if (typeof value === 'object') {
                for (const id of value) {
                    url += `${key}=${id}&`;
                }
            }
            else {
                url += `${key}=${value}&`;
            }
        }
        return apiService.get(url).then((response) => response.json());
    }
    static getSelectableBucketsAndCategories(selectedTags, userId) {
        let query = '';
        if (selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.length) {
            selectedTags.forEach((tag) => {
                query += `&selectedTags[]=${tag}`;
            });
        }
        if (userId) {
            query += `&userId=${userId}`;
        }
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/form_fields/buckets_categories?${query}`));
    }
    static getCurrencies() {
        return apiService.responseToJSONAndToastError(apiService.get('/api/web/metadata/currencies'));
    }
    static getExchangeRate(date, currency, base) {
        const query = `date=${date}&currency=${currency}&base=${base}`;
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/metadata/exchange_rate?${query}`));
    }
    static searchVendors(searchTerm, userId, nearCity, latLon) {
        let query = `query=${searchTerm}&user_id=${userId}`;
        if (nearCity) {
            query += `&near=${nearCity}`;
        }
        if (latLon) {
            query += `&ll=${latLon}`;
        }
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/vendors/search?${query}`));
    }
    static getSearchPlaces(input) {
        let lat;
        let lng;
        navigator.geolocation.getCurrentPosition(function (position) {
            lat = position.coords.latitude;
            lng = position.coords.longitude;
        });
        const searchText = encodeURIComponent(input);
        let query = `query=${searchText}&lat=${lat}&lng=${lng}`;
        const places = apiService.get(`/api/web/organization/integrations/googlemaps/places?${query}`);
        return apiService.responseToJSONAndToastError(places);
    }
    static getPlaceDetails(placeId) {
        let query = `place_id=${placeId}`;
        const placeDetails = apiService.get(`/api/web/organization/integrations/googlemaps/placeDetails?${query}`);
        return apiService.responseToJSONAndToastError(placeDetails);
    }
    static getMapUrl(metadata) {
        const query = stringify({
            origin_lat: metadata.mileage_origin_lat,
            origin_lng: metadata.mileage_origin_lng,
            destination_lat: metadata.mileage_destination_lat,
            destination_lng: metadata.mileage_destination_lng,
            round_trip: metadata.mileage_round_trip
        });
        const data = apiService.get(`/api/web/organization/integrations/googlemaps/directions?${query}`);
        return apiService.responseToJSONAndToastError(data);
    }
}
